import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
// import { RmCountPriceList } from "./rm-count-pricelist-entity";
import { RmCountPriceListController } from "./rm-count-pricelist-controller";
import { RmCountPriceListService } from "./rm-count-pricelist-service";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { LogsService } from "@gtpl/shared-services/user-logs";
import { RmCountPriceListAdapter } from "./dto/rm-count-pricelist.adapter";
import { RmCountPriceListLogsEntity } from "./rm-count-pricelist-logs.entity";
import { RmRates } from "./rm-rates-entity";
import { RmCountRanges } from "apps/services/raw-material-procurement/src/app/raw-material-grn/rm-count-pricelist-entity";
import { ProductCountEntity } from "./product-count-entity";
import { SkuPrice } from "./sku-price-entity";
import { SkuPriceLogs } from "./sku-price-logs-entity";
import { SkuPriceController } from "./sku-price-controller";

@Module({
    imports:[
        TypeOrmModule.forFeature([RmCountPriceListLogsEntity,RmRates,RmCountRanges,ProductCountEntity,SkuPrice,SkuPriceLogs])
    ],
    controllers:[RmCountPriceListController, SkuPriceController],
    providers:[RmCountPriceListService,ApplicationExceptionHandler,LogsService,RmCountPriceListAdapter],
    exports:[RmCountPriceListService]
})
export class RmCountPriceListModule{}